import BillingsOrderCargoRailyRecalculateRequest, {
  BillingsOrderCargoRailyRecalculateRequestBillingNode,
} from "../../../../../api/raily/billings/order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate.request";
import BillingsOrderCargoRailyRecalculateParams, {
  BillingsOrderCargoRailyRecalculateParamsBillingNode,
} from "./billings-order-cargo-raily-recalculate-params";

const createBillingNode = (
  billingNode: BillingsOrderCargoRailyRecalculateParamsBillingNode,
): BillingsOrderCargoRailyRecalculateRequestBillingNode => {
  return {
    id: billingNode.id,
    allowCharge: billingNode.allowCharge,
    checkoutDate: billingNode.checkoutDate,
    checkoutEventId: billingNode.checkoutEventId,
    description: billingNode.description,
    editableCoordinates: billingNode.editableCoordinates,
    haltingTime: billingNode.haltingTime,
    highwayCharge: billingNode.highwayCharge,
    lat: billingNode.lat,
    lon: billingNode.lon,
    nodeId: billingNode.nodeId,
    orderId: billingNode.orderId,
    plannedDate: billingNode.plannedDate,
    distance: billingNode.distance,
    plannedDistance: billingNode.plannedDistance,
  };
};

const createBillingNodes = (
  billingNodes: BillingsOrderCargoRailyRecalculateParamsBillingNode[],
): BillingsOrderCargoRailyRecalculateRequestBillingNode[] => {
  return billingNodes.map(createBillingNode);
};

const create = (
  params: BillingsOrderCargoRailyRecalculateParams,
): BillingsOrderCargoRailyRecalculateRequest => {
  return {
    billingNodes: createBillingNodes(params.billingNodes),
    discount: params.discount,
    orderUuid: params.orderUuid,
  };
};

const billingsOrderCargoRailyRecalculateParamsFactory = {
  create,
};

export default billingsOrderCargoRailyRecalculateParamsFactory;
